/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import { SettingsPageAttackListSenderEditViewEntranceFragmentDoc } from './SettingsPageAttackListSenderEditView.generated';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
/** パートナー、子どもの存在を表すルールに使う */
export type AttackListSenderSettingRuleExistence =
  /** 存在する */
  | 'EXIST'
  /** 存在しない */
  | 'NOT_EXIST'
  /** 指定しない(存在してもしなくてもいい) */
  | 'NOT_SPECIFIED';

export type AttackListSenderSettingRuleGender =
  | 'FEMALE'
  | 'MALE'
  /** 性別は指定しない */
  | 'NOT_SPECIFIED';

export type AttackListSenderSettingRuleInput = {
  age?: AttackListSenderSettingRuleRangeInput | null | undefined;
  ageOfFirstChildRange?: AttackListSenderSettingRuleRangeInput | null | undefined;
  ageOfYoungestChildRange?: AttackListSenderSettingRuleRangeInput | null | undefined;
  annualIncomeRange?: AttackListSenderSettingRuleRangeInput | null | undefined;
  child: AttackListSenderSettingRuleExistence;
  diagnosisType?: DiagnosisType | null | undefined;
  familyAnnualIncomeRange?: AttackListSenderSettingRuleRangeInput | null | undefined;
  gender: AttackListSenderSettingRuleGender;
  investmentRange?: AttackListSenderSettingRuleRangeInput | null | undefined;
  jobId?: string | number | null | undefined;
  karteTopicId?: string | number | null | undefined;
  loanBalanceRange?: AttackListSenderSettingRuleRangeInput | null | undefined;
  partner: AttackListSenderSettingRuleExistence;
  savingRange?: AttackListSenderSettingRuleRangeInput | null | undefined;
  shouldSendIfSameCorporationApproached: boolean;
};

export type AttackListSenderSettingRuleRangeInput = {
  max?: number | null | undefined;
  min?: number | null | undefined;
};

export type CreateAttackListSenderSettingInput = {
  body: string;
  entranceGuid?: string | number | null | undefined;
  isEnabled: boolean;
  plannerId?: string | number | null | undefined;
  rule: AttackListSenderSettingRuleInput;
  selections: Array<string>;
  title: string;
};

export type DiagnosisType =
  | 'A'
  | 'B'
  | 'C'
  | 'D'
  | 'E'
  | 'F'
  | 'G'
  | 'H';

export type CreateAttackListSenderSettingMutationVariables = Exact<{
  input: Types.CreateAttackListSenderSettingInput;
}>;


export type CreateAttackListSenderSettingMutation = { createAttackListSenderSetting: { id: string, isEnabled: boolean, title: string, body: string, selections: Array<string>, planner: { id: string, name: string }, entrance: { guid: string }, rule: { partner: Types.AttackListSenderSettingRuleExistence, child: Types.AttackListSenderSettingRuleExistence, gender: Types.AttackListSenderSettingRuleGender, shouldSendIfSameCorporationApproached: boolean, savingRange: { min: number | null, max: number | null } | null, annualIncomeRange: { min: number | null, max: number | null } | null, familyAnnualIncomeRange: { min: number | null, max: number | null } | null, ageOfFirstChildRange: { min: number | null, max: number | null } | null, age: { min: number | null, max: number | null } | null, investmentRange: { min: number | null, max: number | null } | null } } };

export type FetchOnSettingsPageAttackListSenderCreateViewQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchOnSettingsPageAttackListSenderCreateViewQuery = { viewer: { attackListSender: { availableCorporationEntrances: Array<{ guid: string, name: string }> } } };


export const CreateAttackListSenderSettingDocument = gql`
    mutation createAttackListSenderSetting($input: CreateAttackListSenderSettingInput!) {
  createAttackListSenderSetting(input: $input) {
    id
    isEnabled
    title
    body
    selections
    planner {
      id
      name
    }
    entrance {
      guid
    }
    rule {
      savingRange {
        min
        max
      }
      annualIncomeRange {
        min
        max
      }
      familyAnnualIncomeRange {
        min
        max
      }
      partner
      child
      ageOfFirstChildRange {
        min
        max
      }
      gender
      age {
        min
        max
      }
      investmentRange {
        min
        max
      }
      shouldSendIfSameCorporationApproached
    }
  }
}
    `;

/**
 * __useCreateAttackListSenderSettingMutation__
 *
 * To run a mutation, you first call `useCreateAttackListSenderSettingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateAttackListSenderSettingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateAttackListSenderSettingMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateAttackListSenderSettingMutation(options: VueApolloComposable.UseMutationOptions<CreateAttackListSenderSettingMutation, CreateAttackListSenderSettingMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateAttackListSenderSettingMutation, CreateAttackListSenderSettingMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateAttackListSenderSettingMutation, CreateAttackListSenderSettingMutationVariables>(CreateAttackListSenderSettingDocument, options);
}
export type CreateAttackListSenderSettingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateAttackListSenderSettingMutation, CreateAttackListSenderSettingMutationVariables>;
export const FetchOnSettingsPageAttackListSenderCreateViewDocument = gql`
    query FetchOnSettingsPageAttackListSenderCreateView {
  viewer {
    attackListSender {
      availableCorporationEntrances {
        ...SettingsPageAttackListSenderEditViewEntrance
      }
    }
  }
}
    ${SettingsPageAttackListSenderEditViewEntranceFragmentDoc}`;

/**
 * __useFetchOnSettingsPageAttackListSenderCreateViewQuery__
 *
 * To run a query within a Vue component, call `useFetchOnSettingsPageAttackListSenderCreateViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchOnSettingsPageAttackListSenderCreateViewQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFetchOnSettingsPageAttackListSenderCreateViewQuery();
 */
export function useFetchOnSettingsPageAttackListSenderCreateViewQuery(options: VueApolloComposable.UseQueryOptions<FetchOnSettingsPageAttackListSenderCreateViewQuery, FetchOnSettingsPageAttackListSenderCreateViewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchOnSettingsPageAttackListSenderCreateViewQuery, FetchOnSettingsPageAttackListSenderCreateViewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchOnSettingsPageAttackListSenderCreateViewQuery, FetchOnSettingsPageAttackListSenderCreateViewQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FetchOnSettingsPageAttackListSenderCreateViewQuery, FetchOnSettingsPageAttackListSenderCreateViewQueryVariables>(FetchOnSettingsPageAttackListSenderCreateViewDocument, {}, options);
}
export function useFetchOnSettingsPageAttackListSenderCreateViewLazyQuery(options: VueApolloComposable.UseQueryOptions<FetchOnSettingsPageAttackListSenderCreateViewQuery, FetchOnSettingsPageAttackListSenderCreateViewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchOnSettingsPageAttackListSenderCreateViewQuery, FetchOnSettingsPageAttackListSenderCreateViewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchOnSettingsPageAttackListSenderCreateViewQuery, FetchOnSettingsPageAttackListSenderCreateViewQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FetchOnSettingsPageAttackListSenderCreateViewQuery, FetchOnSettingsPageAttackListSenderCreateViewQueryVariables>(FetchOnSettingsPageAttackListSenderCreateViewDocument, {}, options);
}
export type FetchOnSettingsPageAttackListSenderCreateViewQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FetchOnSettingsPageAttackListSenderCreateViewQuery, FetchOnSettingsPageAttackListSenderCreateViewQueryVariables>;